<script lang="ts">
  import {
    Alignment,
    CSS_ALIGNMENT,
    CSS_SIZE,
    Size,
  } from "$components/editor/extensions/blocks/shared/attributes";
  import Video from "$components/+shared/Video/Video.svelte";
  import cx from "classnames";
  import { NodeViewWrapper } from "svelte-tiptap";
  import HoverMenu from "$components/editor/extensions/blocks/HoverMenu/HoverMenu.svelte";
  import GutterMenu from "../../+shared/GutterMenu.svelte";
  import type { NodeViewProps } from "@tiptap/core";
  import YChangeTooltip from "../../Collaboration/YChangeTooltip.svelte";

  export let node: NodeViewProps["node"];
  export let editor: NodeViewProps["editor"];
  export let deleteNode: NodeViewProps["deleteNode"];
  export let updateAttributes: NodeViewProps["updateAttributes"];
  export let isEditable: boolean;
  export let selected: NodeViewProps["selected"];

  $$restProps; // prevent svelte unused props warning

  type VideoNodeAttributes = {
    src: string;
    width: Size;
    align: Alignment;
    uuid: string | null;
    fileName: string;
    mimeType: string;
    caption: string | undefined;
  };

  $: ({ src, width, align, caption } = attrs);
  $: attrs = node.attrs as VideoNodeAttributes;

  let isLoaded = false;
  let isUploading = false;

  const changeSize = (newWidth: string) => {
    width = newWidth as Size;
    updateAttributes({ width: newWidth });
  };

  const setAlign = (newAlign: string) => {
    align = newAlign as Alignment;
    updateAttributes({ align: newAlign });
  };
</script>

<NodeViewWrapper
  {editor}
  class={cx("not-prose group relative my-2 flex rounded", CSS_ALIGNMENT[align])}
>
  {#if isEditable}
    <GutterMenu on:delete-block={deleteNode} />
  {/if}

  <YChangeTooltip ychange={node.attrs.ychange} />

  {#if src && !isUploading}
    <!-- /* Got a video, show it */ -->
    <div
      class={cx(CSS_SIZE[width], !isLoaded && "relative min-h-[150px]")}
      class:ring={(selected && isEditable) || node.attrs.ychange}
      class:ring-offset-4={node.attrs.ychange}
      class:ring-green-500={node.attrs.ychange?.type == "added"}
      class:ring-red-500={node.attrs.ychange?.type == "removed"}
    >
      <Video class="h-full w-full rounded" {src} on:load={() => (isLoaded = true)} />
      {#if caption}
        <div class="my-1 text-center text-[13px] font-normal text-neutral-500">
          {caption}
        </div>
      {/if}
      {#if isEditable}
        <div
          class="absolute inset-x-0 bottom-0 z-[999] mb-2 hidden translate-y-full justify-center group-hover:flex"
        >
          <HoverMenu
            parentType="video"
            {align}
            {width}
            {caption}
            on:sizeChange={(e) => changeSize(e.detail)}
            on:alignChange={(e) => setAlign(e.detail)}
            on:captionChange={(e) => updateAttributes({ caption: e.detail })}
          />
        </div>
      {/if}
    </div>
  {/if}
</NodeViewWrapper>
